// extracted by mini-css-extract-plugin
export default {"tag":"ValidationTag_tag__60Th2"};